import React from 'react';

const StepTitle = ({ stepTitleContent }) => {
  return (
    <div className=''>
      <div className='text-xl md:text-3xl font-semibold pl-0 mb-3 text-dms-primary'>
        {stepTitleContent}
      </div>
    </div>
  );
};

export default StepTitle;
